var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFilterNew02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.07324 3.85032C2.07324 2.86833 2.8693 2.07227 3.8513 2.07227H12.1489C13.1309 2.07227 13.9269 2.86833 13.9269 3.85032V4.54469C13.9269 5.01626 13.7396 5.46851 13.4062 5.80197C13.4062 5.80198 13.4062 5.80197 13.4062 5.80197L9.95175 9.25638C9.84058 9.36755 9.77815 9.5183 9.77815 9.67547V11.0642C9.77815 11.5358 9.59082 11.9881 9.25736 12.3215L7.95227 13.6266C7.31381 14.2651 6.22204 13.8129 6.22204 12.9099V9.67547C6.22204 9.51831 6.1596 9.36755 6.04843 9.25637L2.59402 5.80197C2.26057 5.46852 2.07324 5.01627 2.07324 4.54469V3.85032ZM3.8513 3.25764C3.52397 3.25764 3.25861 3.52299 3.25861 3.85032V4.54469C3.25861 4.70189 3.32105 4.85264 3.43221 4.96379L6.88663 8.4182C7.22006 8.75166 7.40741 9.20391 7.40741 9.67547V12.4951L8.41918 11.4833C8.53035 11.3722 8.59278 11.2214 8.59278 11.0642V9.67547C8.59278 9.20391 8.7801 8.75167 9.11357 8.4182L12.568 4.96379C12.6791 4.85264 12.7416 4.70189 12.7416 4.54469V3.85032C12.7416 3.52298 12.4762 3.25764 12.1489 3.25764H3.8513Z",
    fill: "#4A5467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilterNew02);
export default __webpack_public_path__ + "static/media/ic-filter-new-02.ac51c5bb32f41db5881cf8bbb467fd82.svg";
export { ForwardRef as ReactComponent };